
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/v2/funnel/[practice]",
      function () {
        return require("private-next-pages/v2/funnel/[practice]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/v2/funnel/[practice]"])
      });
    }
  